import styles from "./MicStatus.module.scss";

export const MicStatus = ({ status }) => {
  return (
    <div className={styles.recording_container}>
      {status === "active" ? (
        <>
          <span>{`🟢`}</span>
        </>
      ) : status === "not-active" ? (
        <>
          <span>{`🔴`}</span>
        </>
      ) : (
        `🟥`
      )}
    </div>
  );
};
